export const resolveDocsRoute = (rulename: string): string => {
  return `https://github.com/lasselupe33/eslint-plugin-comment-length/tree/master/src/rules/${rulename}/docs.md`;
};
